export const BONUS_AMOUNTS = '/bonus/bonusAmount'
export const BONUS_WAGERING = '/wagering/wageringComplete'
